'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ListContainer = require('./ListContainer');

var _FloatingButton = require('../../Presentational components/FloatingButton/FloatingButton');

var _FloatingButton2 = _interopRequireDefault(_FloatingButton);

var _Request = require('../../Request');

var _Request2 = _interopRequireDefault(_Request);

var _actions = require('../DrawerMenuContainer/actions');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var navigate = function navigate(dispatch, route) {
  dispatch((0, _reactRouterRedux.push)(route));
};

var BaseList = function (_React$Component) {
  _inherits(BaseList, _React$Component);

  function BaseList(props, context) {
    _classCallCheck(this, BaseList);

    var _this = _possibleConstructorReturn(this, (BaseList.__proto__ || Object.getPrototypeOf(BaseList)).call(this, props, context));

    _this.List = (0, _ListContainer.listBuilder)(props.mapStateToProps);
    if (props.appBar) {
      _this.context.store.dispatch((0, _actions.setAppBar)(props.appBar));
    }
    _this.onSuccess = _this.onSuccess.bind(_this);
    return _this;
  }

  _createClass(BaseList, [{
    key: 'onSuccess',
    value: function onSuccess(result, dispatch, props, state) {
      if (props.onResult) {
        props.onResult(result, dispatch, props, state);
      }
      var navigateTo = navigate.bind(null, dispatch, props.route);
      var List = this.List;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(List, null),
        _react2.default.createElement(_FloatingButton2.default, {
          type: 'add',
          style: props.buttonStyle || {},
          onMouseUp: navigateTo,
          onTouchEnd: navigateTo
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Request2.default, _extends({ request: this.props.request, onSuccess: this.onSuccess }, this.props));
    }
  }]);

  return BaseList;
}(_react2.default.Component);

BaseList.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  route: _react2.default.PropTypes.string.isRequired,
  appBar: _react2.default.PropTypes.object,
  mapStateToProps: _react2.default.PropTypes.func.isRequired,
  request: _react2.default.PropTypes.func.isRequired
};
BaseList.contextTypes = {
  store: _react2.default.PropTypes.object.isRequired
};
exports.default = (0, _reactIntl.injectIntl)(BaseList);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/ListContainer/BaseList.js
 ** module id = 128
 ** module chunks = 0
 **/